<script>
    import {flow_steps, emitter} from '../stores.js';
    
    import {querystring, link, location, push, pop, replace} from 'svelte-spa-router';
    // import ProgressBar from "@okrad/svelte-progressbar";

    import { onMount } from "svelte";

    export let show_progress_ring = true;
    export let override_urlcheck = false;
    export let title;
    export let pre_next_callback_function = undefined;
    export let pre_back_callback_function = undefined;
    export let next_function = undefined;
    export let show_next_button = true;
    export let show_prev_button = true;
    // export let progress = "0";
    let pct_done = 0;
    let my_loc = 1;
    let circle;
    let moused_over_button = false;
    let pbar;
    // export let step_info = undefined;
    // let series = [
    //     {
    //         perc: pct_done,
    //         // perc: progress,
    //         color: '#EF4642'
    //     }
    // ];

    
    // async function doBackFunction(){
    //     let doback = false;
    //     if(pre_back_callback_function !== undefined){
    //         doback = await pre_back_callback_function();
    //     }else{
    //         doback = true;
    //     }
    //     if(doback){
    //         // console.log($flow_steps.current_flow);
    //         if($flow_steps.current_flow === ""){
    //             pop();
    //         }else{
    //             if(my_loc >= 2){
    //                 push($flow_steps.flows[$flow_steps.current_flow][my_loc - 2]);
    //             }else {
    //                 pop();
    //             }
    //         }

    //     }

    // }

    async function doBackFunction(){
// console.log("doing back function");
        const params = new URLSearchParams($querystring)
        if(params.has('b')){
console.log("doing back function from url");
            push($flow_steps.flows[params.get("f").toString()][params.get("b")]);
        }else{
console.log("doing back function from store");
            push($flow_steps.flows[$flow_steps.current_flow][$flow_steps.current_prev_loc]);
        }                            

    }

    async function doForwardFunction(){

        let donext = false;
        if(pre_next_callback_function !== undefined){
            donext = await pre_next_callback_function();
            // console.log(donext);
        }else{
            donext = true;
        }

        console.log($flow_steps);

        if(donext){
            if(next_function !== undefined){
// console.log("... doing next with next function");
                next_function(()=>{
                    if($flow_steps.current_flow !== ""){
                        if(my_loc < $flow_steps.flows[$flow_steps.current_flow].length){
                            const params = new URLSearchParams($querystring)
                            
                            // push($flow_steps.flows[$flow_steps.current_flow][my_loc]);
                            push($flow_steps.flows[params.get("f").toString()][params.get("n")]);
                        }
                    }
                        // push(next_page);
                });
            }else{
// console.log("... doing next without next function");
                const params = new URLSearchParams($querystring)
                if(params.has('n') && !override_urlcheck){
console.log("using url to get next");
                    push($flow_steps.flows[params.get("f").toString()][params.get("n")]);
                }else{
console.log("using store to get next");
                    push($flow_steps.flows[$flow_steps.current_flow][$flow_steps.current_next_loc]);
                }                            
                            // push($flow_steps.flows[$flow_steps.current_flow][my_loc]);
                // console.log($flow_steps);
                // if($flow_steps.current_flow !== ""){
                //     if(my_loc < $flow_steps.flows[$flow_steps.current_flow].length){
                //         push($flow_steps.flows[$flow_steps.current_flow][my_loc]);
                //     }
                // }
                // push(next_page);

            }

        }


    }

    // let ProgressBar;
    let progress_bar;
    let progress_bar_container;

    // let stroke_dash_offset = "0";
    // function toRadians (angle) {
    //     return angle * (Math.PI / 180);
    // }
    let polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
        let angleInRadius = angleInDegrees * Math.PI / 180;
        let x = centerX + Math.sin(angleInRadius) * radius;
        let y = centerY - Math.cos(angleInRadius) * radius;
        return { x: x, y: y };
    };

    function isForwardDirection(pd){
        // console.log(`pd: ${pd}`);
        // console.log(`current_percentage: ${$flow_steps.current_percentage}`);

        let forward_direction = false;
        if(pd > $flow_steps.current_percentage){
            forward_direction = true;
        }

        return forward_direction;
    }

    function getPercentDone(){
        const params = new URLSearchParams($querystring)
// console.log(params.get("p"));
        // my_loc = $flow_steps.flows[$flow_steps.current_flow].indexOf($location) + 1;
        // const clean_flow_steps = $flow_steps.flows[$flow_steps.current_flow].map(e => return e.);
// console.log(clean_flow_steps);
// console.log($flow_steps.current_flow);
// console.log($location);

        if (params.has("p")) {
            // const pct_done = params.get("p");
            return parseInt(params.get("p").toString(), 16);
        }else{
            return 0;
        }

        // const flows = Object.keys($flow_steps.flows);
//         let current_location = 1;
//         let num_steps = 1;

// // console.log($flow_steps);
//         if($flow_steps.current_flow === ""){

//             for(let i = 0; i < flows.length; i++){
//                 let next_len = $flow_steps.flows[flows[i]].length;
//                 if(next_len > num_steps){
//                     num_steps = next_len;
//                 }
//             }
//             // pct_done = Math.floor((1 / num_steps) * 100);
//             return Math.floor((1 / num_steps) * 100);
//             // pct_done = 75.0;
//             // series[0]['perc'] = pct_done;

//         }else{

//             num_steps =  $flow_steps.flows[$flow_steps.current_flow].length;
//             my_loc = $flow_steps.flows[$flow_steps.current_flow].indexOf($location) + 1;
//             // pct_done = Math.floor((my_loc / num_steps) * 100);
//             return Math.floor((my_loc / num_steps) * 100);
//             // series[0]['perc'] = pct_done;
//         }

    }

    function setProgress(pd){
// console.log("setting progress: ", pd);
        let factor = 1.58611; //how to figure this out?
        let angle = parseInt((pd/100)*360*factor);
        // progress_bar_container.setAttribute("data-pct", parseInt((angle*100)/(360*factor)));
        progress_bar_container.setAttribute("data-pct", parseInt(pd));
        circle.setAttribute("stroke-dasharray", angle + ", 20000");

    }

    function animateProgress(pd){
        // setProgress(pd);
        let factor = 1.58611; //how to figure this out?
        let update_interval = 50;
        let start_percentage = $flow_steps.current_percentage
        let start_angle = parseInt((start_percentage/100)*360*factor);
        let angle_increment = 6;
        let end_percentage = pd;
        let end_angle = parseInt((end_percentage/100)*360*factor);
// console.log(`start_percentage: ${start_percentage}`);
// console.log(`start_angle: ${start_angle}`);
// console.log(`end_percentage: ${end_percentage}`);
// console.log(`end_angle: ${end_angle}`);
        let forward_direction = isForwardDirection(pd);
        // if(start_percentage > end_percentage){
        //     forward_direction = false;
        // }
// console.log(`forward_direction: ${forward_direction}`);

        let current_angle = start_angle;
        let current_percent = start_percentage;

        let _timer = setInterval(() => {
        

            if(forward_direction){
                if(current_angle >= end_angle || circle === null){
                    setProgress(end_percentage);
                    $flow_steps.current_percentage = end_percentage;
                    clearInterval(_timer);
                }else{
// console.log(`current_angle f: ${current_angle}`);
// console.log(`current_percent f: ${current_percent}`);                   
                    setProgress(current_percent);
                    current_angle += angle_increment;
                    current_percent = parseInt(100*(current_angle / (360*factor)));
                }

            }else{
                if(current_angle <= end_angle || circle === null){
                    setProgress(end_percentage);
                    $flow_steps.current_percentage = end_percentage;
                    clearInterval(_timer);
                }else{
// console.log(`current_angle r: ${current_angle}`);
// console.log(`current_percent r: ${current_percent}`);                   
                    setProgress(current_percent);
                    current_angle -= angle_increment;
                    current_percent = parseInt(100*(current_angle / (360*factor)));
                }

            }

        }, update_interval);
    }

    function animateProgress_old_good(pd) {
    // var circle = document.getElementById('red-halo');
    // var progress_text = document.getElementById('progress-text');
    let interval = 30;
    let angle = 0;
    let angle_increment = 6;
    let factor = 1.58611;
    let percentage = pd;
    let max_angle = parseInt((percentage/100)*360*factor);

    let _timer = setInterval(function () {
// console.log("doing progress: ", angle);
// console.log(circle);
    
        if (angle >= max_angle || circle === null) {
// console.log("cancelling progress.");
// console.log(`updating current_percentage to: ${pd}`);
            $flow_steps.current_percentage = pd;
            clearInterval(_timer);
        }else{
            progress_bar_container.setAttribute("data-pct", parseInt((angle*100)/(360*factor)));
            circle.setAttribute("stroke-dasharray", angle + ", 20000");
        // circle.setAttribute("stroke", "hsl(1, 84%, 60%)");
        // progress_text.innerHTML = parseInt(angle/(360*factor)*100) + '%';

        }
        angle += angle_increment;
    }, interval);
}

    function animateProgress_old(pd){
// console.log("animating with: ", pd);
        const angle = 360 * (pd/100);
        const steps = 32;
        let step = 0;
        let tangle = 0;
        let direction = 0;
        let _timer = setInterval(() => {
            const coords = polarToCartesian(118, 118, 100, tangle);
            tangle = tangle + angle/steps;
            if(tangle > 180){
                direction = 1;
            } else {
                direction = 0;
            }

            progress_bar.setAttribute("d", `M 118 18 A 100 100 0 ${direction} 1 ${coords.x} ${coords.y}`);

            step = step + 1;
            if (step >= steps){
                clearInterval(_timer);
            }            
        }, 1000/steps);
        // d="M 118 18 A 100 100 0 1 1 45.10313725785886 186.45471059286888"

        // var FPS = 30;
        // setInterval(function() {
        //     update();
        //     draw();
        // }, 1000/FPS);

        // setTimeout(() => {
        //     const r = 100;
        //     const angle = 0;
        //     const coords = polarToCartesian(118, 118, 100, 0);
        //     console.log(coords);
        //     // let x = (r * Math.sin(toRadians(angle))) +  100;
        //     // let y = 100 - (r * Math.cos(toRadians(angle)));
            
        //     progress_bar.setAttribute("d", `M 118 18 A 100 100 0 0 1 ${coords.x} ${coords.y}`);
        //     // progress_bar.setAttribute("d", "M 118 18 A 100 100 0 0 1 208.48270524660194 75.42207084349272");
        // }, 1000);



//         The point (0,𝑟) ends up at 𝑥=𝑟sin𝜃, 𝑦=𝑟cos𝜃.

// In general, suppose that you are rotating about the origin clockwise through an angle 𝜃. Then the point (𝑠,𝑡) ends up at (𝑢,𝑣) where
// 𝑢=𝑠cos𝜃+𝑡sin𝜃and𝑣=−𝑠sin𝜃+𝑡cos𝜃.

    }

    onMount(async () => {



        setTimeout(() => {
            $emitter.on('progressClick', ()=>{
                doForwardFunction();
            });

            let val = parseInt(pct_done);


            if (isNaN(val)) {
            val = 0; 
            } else{
                // var r = progress_bar.getAttribute("r");
                // var c = Math.PI*(r*2);

                if (val < 0) { val = 0;}
                if (val > 100) { val = 100;}
                
                // var pct =  ((val)/100)*c;

                // progress_bar_container.setAttribute("data-pct", val);
                // progress_bar.style["stroke-dashoffset"] = pct;
            }
            animateProgress(val);
            // console.log("I changed the percent")
        }, 100);
        // set percentage
        pct_done = getPercentDone();
        setProgress($flow_steps.current_percentage);
        // let fd = isForwardDirection(pct_done);
        // if(fd){
        // }else{

        // }
//         const flows = Object.keys($flow_steps.flows);
//         let current_location = 1;
//         let num_steps = 1;

// // console.log($flow_steps);
//         if($flow_steps.current_flow === ""){

//             for(let i = 0; i < flows.length; i++){
//                 let next_len = $flow_steps.flows[flows[i]].length;
//                 if(next_len > num_steps){
//                     num_steps = next_len;
//                 }
//             }
//             pct_done = Math.floor((1 / num_steps) * 100);
//             // pct_done = 75.0;
//             // series[0]['perc'] = pct_done;

//         }else{

//             num_steps =  $flow_steps.flows[$flow_steps.current_flow].length;
//             my_loc = $flow_steps.flows[$flow_steps.current_flow].indexOf($location) + 1;
//             pct_done = Math.floor((my_loc / num_steps) * 100);
//             // series[0]['perc'] = pct_done;
//         }

    });

 

</script>

<div class="maincontainer {(show_progress_ring === false) ? "hideprogress" : ""}">
    <div bind:this={progress_bar_container} class="progresscontainer" data-pct="0">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 200 200" preserveAspectRatio="none" style="width:100; height:100; top:0; left:0;">
            <circle cx="100" cy="100" r="91" fill="none" stroke="#dddddd" stroke-width="18" transform="rotate(-90,100,100)" />
          <circle cx="100" cy="100" r="91"  bind:this={circle} fill="none" stroke="hsl(1, 84%, 60%)" stroke-width="18" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" />
          <!-- <text id="progress-text" text-anchor="middle" x="100" y="115" fill="#000000" style="font-size: 48px; font-weight: 700; font-family: proxima-nova, sans-serif;" >0%</text> -->
      </svg>

        <!-- <svg xmlns="http://www.w3.org/2000/svg"
         preserveAspectRatio="xMidYMid meet" 
         viewBox="0 0 236 236" 
         height="100%" 
         width="100%" 
         >
            <defs>
                <linearGradient 
                id="edge-removal">
                <stop offset="5%" stop-color="#EF4642" stop-opacity="1"></stop>
                <stop offset="95%" stop-color="#EF4642" stop-opacity="1"></stop>
            </linearGradient>
             
            
            </defs>
            
            <circle 
            cx="118" 
            cy="118" 
            r="100" 
            fill="none" 
            stroke="#e6e7e8" 
            stroke-width="18" 
            >
            </circle>
            
            <path bind:this={progress_bar} id="progressbar"
            stroke="#EF4642" 
            d="M 118 18 A 100 100 0 0 1 118 18"
            stroke-width="18" 
            stroke-linecap="flat" 
            fill="none" 
            >
            </path>
        </svg> -->

        
          <!-- <svg id="svg" 
          width="100" 
          height="100" 
          viewPort="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter id="edge-removal">
                    <feComponentTransfer>
                        <feFuncA type="table" tableValues="0 0 0 0 0 0 0 0 0 0 1" />
                    </feComponentTransfer>
                </filter>                
            </defs> -->

            <!-- <g filter="url(#edge-removal)"> -->
            <!-- <g>
            <circle 
            r="45" 
            cx="50" 
            cy="50" 
            fill="transparent" 
            stroke-dasharray="282.74" 
            shape-rendering="crispEdges"
            stroke-dashoffset="0"></circle>
            
            <circle bind:this={progress_bar} 
            id="bar" 
            r="45" 
            cx="50" 
            cy="50" 
            fill="transparent" 
            stroke-dasharray="282.74" 
            stroke-dashoffset="0"
            shape-rendering="crispEdges"
            transform="rotate(-90, 50, 50) scale(1, -1) translate(0, -100)"
            ></circle>
            </g>
        </svg> -->

    </div>
    <div class="titlecontainer">{title}</div>

    <div class="infocontainer">
        <slot></slot>
    </div>

    <div class="buttoncontainer">
        {#if show_prev_button}
        <button on:click={()=>{ doBackFunction(); }} class=" backbutton"><span class="backarrowcontainer"><img class="{(moused_over_button) ? "backarrowcontainerwhite" : ""}" src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
        {/if}
        {#if show_next_button}
        <button on:click={()=>{doForwardFunction()
            ;}} class="darken nextbutton">Next</button>
        {/if}
    </div>
</div>

<style>

#svg circle {
  stroke-dashoffset: 0;
  transition: stroke-dashoffset 1s linear;
  stroke: #EF4642;
  stroke-width: 0.5em;
}
#svg #bar {
  stroke: #e6e7e8;
}
/* #progressbar { */
    /* transition: all 0.5s ease-in-out; */
/* } */

.maincontainer {
    width: 100%;
    height: auto;
    background-color: white;
    min-height: 450px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    padding-top: 0px;
}
.progresscontainer {
    /* width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px; */
    display: block;
    height: 100px;
    width: 100px;
    margin: 2em auto;
    /* box-shadow: 0 0 1em black; */
    border-radius: 100%;
    position: relative;
}
/* #cont {
  display: block;
  height: 200px;
  width: 200px;
  margin: 2em auto;
  box-shadow: 0 0 1em black;
  border-radius: 100%;
  position: relative;
} */
.progresscontainer:after {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  padding: 0px;
  /* display: block; */
  /* height: 100px; */
  /* width: 100px; */
  /* margin-top: -100px; */
  /* left: 50%;
  top: 50%; */
  content: attr(data-pct)"%";
  /* margin-top: -80px;
  margin-left: -80px;
  border-radius: 100%;
  line-height: 160px; */
  font-size: 1.5em;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 160px; */
  /* width: 160px; */
  /* box-shadow: inset 0 0 1em black; */
  /* text-shadow: 0 0 0.5em black; */
}

.titlecontainer {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-weight: 500;
    font-size: 2em;
    padding-left: 25px;
    padding-right: 25px;
    /* margin-top: 15px; */
}
.infocontainer {
    margin-top: 25px;
    text-align: center;
}
.buttoncontainer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
}
.backarrowcontainer {
    margin-right: 10px;
}
.backarrowcontainer img{
    width: 10px;
    height: 10px;
}
.backarrowcontainerwhite{
    filter: invert(1);
}
.buttoncontainer button {
    width: 150px;
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}
/* .buttoncontainer button:hover {
    background-color: #2c313d;
    color: white;
} */
.backbutton {
    transition: all 0.25s linear;
}
.backbutton:hover, .backbutton:focus {
    background-color: #999;
    /* color: white; */
    transition: all 0.25s linear;
}
.nextbutton {
    color: white;
    background-color: var(--semperred);
    margin-left: 15px;
    transition: all 0.25s linear;
}
:global(.hideprogress > .progresscontainer) {
    display: none !important;
}
:global(.hideprogress) {
   margin-top: 100px !important;
}

@media (max-device-width: 1200px), (max-width: 1199px) {
    .titlecontainer {
        width: 80%;
    }
    .buttoncontainer {
        flex-direction: column-reverse;
        align-items: center;
    }
    .buttoncontainer button {
        width: 80%;
    }
    .nextbutton {
        margin-left: 0px;
        margin-bottom: 50px;
        padding: 16px !important;
        font-size: 1.25em;
        font-weight: 600;
    }
    .backbutton {
        width: 100px !important;
    }
}
</style>